import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "3.3",
      d: "M9 8.65h22A2.35 2.35 0 0 1 33.35 11v13A2.35 2.35 0 0 1 31 26.35H13.48a5.65 5.65 0 0 0-3.677 1.36L6.65 30.411V11A2.35 2.35 0 0 1 9 8.65Z"
    }, null, -1)
  ]))]))
}
export default { render: render }